import styled from 'styled-components';
import { MdFileUpload } from 'react-icons/md';

import useUserImage from '../hooks/useUserImage';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

const UserImageView = styled.div`
  position: relative;
  width: 160px;
  height: 160px;
`;

const UserImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 100%;
  object-fit: cover;
  object-position: center;
  border: 1px solid ${(props) => props.theme.global.borderColor};
`;

const UploadButtonView = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;

  input {
    width: 0;
    height: 0;
    margin: 0;
    padding: 0;
    opacity: 0;
  }
`;

const UploadButton = styled.label`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  background-color: ${(props) => props.theme.global.mainColor};
  border-radius: 100%;
  color: #ffffff;
  cursor: pointer;
`;

const DeleteButton = styled.button`
  font-size: 14px;
  color: ${(props) => props.theme.global.lightTextColor};

  &:hover {
    text-decoration: underline;
    text-underline-position: under;
  }
`;

const AvatorUploader = () => {
  const { userImageUrl, onFileChange, onDeleteButtonClick } = useUserImage();

  return (
    <Container>
      <UserImageView>
        <UserImage src={userImageUrl} />
        <UploadButtonView>
          <input id="upload" type="file" onChange={onFileChange} accept="image/jpg, image/jpeg, image/png" />
          <UploadButton htmlFor="upload">
            <MdFileUpload />
          </UploadButton>
        </UploadButtonView>
      </UserImageView>
      <DeleteButton onClick={onDeleteButtonClick}>이미지 삭제</DeleteButton>
    </Container>
  );
};

export default AvatorUploader;
